import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import FilterTicket from '../Filter/FilterTicket';
import FilterTicketMember from '../Filter/FilterTicketMember';
import { CheckPermissionComponent } from '../../util/permission';
import { TICKET_LIST_ALL_VIEW, TICKET_LIST_MEMBER_VIEW } from '../../constants/menuPermissionConstant';

class TicketChannel extends Component {
    render() {
        return (
            <>
                <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW]} userPermission={this.props.userDetail.permissions}>
                    {window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) && <FilterTicket handleFilter={this.props.handleFilter} resetFilter={this.props.resetFilter} />}
                </CheckPermissionComponent>
                <CheckPermissionComponent permissionConstant={[TICKET_LIST_MEMBER_VIEW]} userPermission={this.props.userDetail.permissions}>
                    {window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER) && <FilterTicketMember handleFilter={this.props.handleFilter} resetFilter={this.props.resetFilter} />}
                </CheckPermissionComponent>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetail: state.authentication.userDetail
    };
};

export default connect(mapStateToProps, null)(TicketChannel);